import classnames from "classnames";

import "./productTitle.scss";

type TitleProps = {
    title: string;
    lines?: 1 | 2 | 3 | 4 | 5;
    className?: string;
};

const ProductTitle = ({ title, lines = 2, className }: TitleProps) => {
    return (
        <div
            className={classnames(
                "productTitle text-primary heading-5 my-0",
                `clamp-${lines}`,
                `productTitle-${lines}`,
                className
            )}
        >
            {title}
        </div>
    );
};

export default ProductTitle;
